import { useDragDrop } from '../UICalendarDragDropProvider';
import { DropComponent } from './hasDep';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function DropTarget({
  render,
  droppedMoment,
  viewType
}) {
  const {
    hasDragDrop,
    onDndDrop,
    onDndHover,
    dragGroup,
    canDrop
  } = useDragDrop();
  if (!hasDragDrop) {
    return render({
      isDragging: false,
      isOver: false,
      canDropResult: false,
      isSameTime: false,
      dropTarget: /*#__PURE__*/_jsx(_Fragment, {}),
      containerRef: {
        current: null
      }
    });
  }
  return /*#__PURE__*/_jsx(DropComponent, {
    droppedMoment: droppedMoment,
    canDrop: canDrop,
    onDndDrop: onDndDrop,
    onDndHover: onDndHover,
    dragGroup: dragGroup,
    render: render,
    viewType: viewType
  });
}